"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkstreamTrafficControl = exports.WorkstreamTrafficControlDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var client_1 = require("@apollo/client");
var client_2 = require("@apollo/client");
var wait_message_1 = require("../elements/wait-message");
var use_lang_1 = require("../../hooks/use-lang");
var grid_1 = require("../elements/grid");
var html_1 = require("../elements/html");
var team_role_card_1 = require("./team-role-card");
var icon_button_1 = require("../elements/icon-button");
// -------- GraphQL -------->
var QUERY = (0, client_2.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TrafficControlTeamQuery($id: ID!) {\n    team(id: $id) {\n      id\n      name\n      slug\n      description { id text html }\n      members {\n        id\n        name\n        role {\n          id\n          name\n          slug\n        }\n        person {\n          id\n          name\n          slug\n          position\n          photo {\n            id\n            url\n          }\n          organisation {\n            id\n            name\n            slug\n          }\n        }\n      }\n    }\n  }\n\n"], ["\n  query TrafficControlTeamQuery($id: ID!) {\n    team(id: $id) {\n      id\n      name\n      slug\n      description { id text html }\n      members {\n        id\n        name\n        role {\n          id\n          name\n          slug\n        }\n        person {\n          id\n          name\n          slug\n          position\n          photo {\n            id\n            url\n          }\n          organisation {\n            id\n            name\n            slug\n          }\n        }\n      }\n    }\n  }\n\n"])));
exports.WorkstreamTrafficControlDefaultProps = {
  teamId: "traffic-control"
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0 ", ";\n    padding-bottom: ", ";\n    padding-top: ", ";\n    background: #EBEBEB;\n    color: ", ";\n  "], ["\n    padding: 0 ", ";\n    padding-bottom: ", ";\n    padding-top: ", ";\n    background: #EBEBEB;\n    color: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.COLOR('text')),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " 0;\n  "], ["\n    padding: ", " ", " 0;\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5))
});
var WaitMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    font-weight: 500;\n    margin: 0 0 ", ";\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    font-weight: 500;\n    margin: 0 0 ", ";\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(4))
});
var PeopleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n    line-height: 1.5em;\n  "], ["\n    color: ", ";\n    line-height: 1.5em;\n  "])), theme_1.theme.COLOR('text'))
});
var TeamRoleCardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HelpRequestCardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    padding: ", ";\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    box-sizing: border-box;\n  "], ["\n    display: flex;\n    padding: ", ";\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    box-sizing: border-box;\n  "])), theme_1.theme.UNIT(4), theme_1.theme.COLOR('light'))
});
var HelpRequestLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  WaitMessage: (0, styled_components_1.default)(wait_message_1.WaitMessage)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles),
  Body: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled_components_1.default.h2(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Intro: styled_components_1.default.p(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  People: (0, styled_components_1.default)(grid_1.Grid)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PeopleStyles),
  TeamRoleCard: (0, styled_components_1.default)(team_role_card_1.TeamRoleCard)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), TeamRoleCardStyles),
  HelpRequestCard: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), HelpRequestCardStyles),
  HelpRequestLink: (0, styled_components_1.default)(icon_button_1.CreateIconButton)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), HelpRequestLinkStyles)
};
var WorkstreamTrafficControl = function (props) {
  var className = props.className,
    teamId = props.teamId;
  var t = (0, use_lang_1.useLang)();
  var _a = (0, client_1.useQuery)(QUERY, {
      variables: {
        id: teamId
      }
    }),
    data = _a.data,
    loading = _a.loading;
  var team = data && data.team;
  return team ? React.createElement(My.Container, {
    className: className
  }, loading ? React.createElement(My.WaitMessage, null, t('Please wait...')) : React.createElement(My.Body, null, React.createElement(My.Title, null, t('Activity Traffic Control'), ":"), React.createElement(My.Intro, null, React.createElement(html_1.HTML, {
    text: team.description.text
  })), React.createElement(My.People, {
    columns: 3,
    items: team.members.map(function (teamRole) {
      return React.createElement(My.TeamRoleCard, {
        entity: teamRole,
        to: "mailto:".concat(process.env.SUPPORT_EMAIL)
      });
    }).concat(React.createElement(My.HelpRequestCard, null, React.createElement(My.HelpRequestLink, {
      to: "mailto:".concat(process.env.SUPPORT_EMAIL)
    }, "Submit Help Request")))
  }))) : null;
};
exports.WorkstreamTrafficControl = WorkstreamTrafficControl;
exports.WorkstreamTrafficControl.defaultProps = exports.WorkstreamTrafficControlDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;